import React from "react";
import YourActivitySection from "../components/YourActivitySection";

function Activity() {
  return (
    <div className="px-6 py-6 space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Your Activity</h1>
        <p className="text-slate-300">
          Track your recent activities and progress
        </p>
      </div>

      <YourActivitySection />
    </div>
  );
}

export default Activity;
